import React from 'react';

const usePrevious = <T>(value: T): T | undefined => {
  const ref = React.useRef<T>(undefined);

  React.useEffect(() => {
    ref.current = value;
  }, [value]);

  // eslint-disable-next-line react-hooks/refs
  return ref.current;
};

export default usePrevious;
